/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */

/**
 * type of Tariff
 */
export type TariffType = (typeof TariffType)[keyof typeof TariffType]

export const TariffType = {
  Standard: "Standard",
  Green: "Green",
  EV: "EV",
} as const
